/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/useAuth";
import { URLS } from "../../../infra/URLS";
import { Botao } from "../Botao";
import { Logo } from "../../Icons/Logo";

interface NavbarProps {
  content?: any;
}

export function Navbar({ content }: NavbarProps) {
  const auth = useAuth();
  const navigate = useNavigate();

  function Logout() {
    auth.logout();
    navigate(URLS.LOGIN);
  }

  return (
    <nav className="fixed z-20 bg-white shadow-md w-full py-1">
      <div className="relative flex items-center justify-between px-10">
        <div className="w-[7%]">
          <Logo height="3.5rem" />
        </div>
        {
          content &&
          <div className="flex gap-3 items-center justify-center">
            {content}
          </div>
        }
        <Botao texto="Sair" onClick={Logout} className="bg-primary hover:bg-primary-hover text-white" />
      </div>
    </nav>
  );
}
